function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { nanoid } from 'nanoid';
import Log from '@deephaven/log';
import TimeoutError from "./TimeoutError.js";
import { assertNotNull } from "./Asserts.js";
var log = Log.module('MessageUtils');
/**
 * Make response object for given message id
 * @param messageId Id of the request message to respond to
 * @param payload Payload to respond with
 * @returns Response
 */
export function makeResponse(messageId, payload) {
  return {
    id: messageId,
    payload
  };
}

/**
 * Get the parent window of the current window.
 */
export function getWindowParent() {
  if (window.opener != null) {
    return window.opener;
  }
  if (window.parent != null && window.parent !== window) {
    return window.parent;
  }
  return null;
}

/**
 * Check if the given object is a valid PostMessage object.
 * @param obj Object to check
 * @returns True if the object is a valid PostMessage, false otherwise
 */
export function isMessage(obj) {
  var message = obj;
  return message != null && typeof message.id === 'string' && typeof message.message === 'string';
}

/**
 * Check if the given object is a valid PostMessageResponse object.
 * @param obj Object to check
 * @returns True if the object is a valid PostMessageResponse, false otherwise
 */
export function isResponse(obj) {
  var response = obj;
  return response != null && typeof response.id === 'string';
}

/**
 * Make message object with optional payload
 * @param message Message string
 * @param id Unique message id
 * @param payload Payload to send
 * @returns Message
 */
export function makeMessage(message) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nanoid();
  var payload = arguments.length > 2 ? arguments[2] : undefined;
  return {
    message,
    id,
    payload
  };
}

/**
 * Request data from the parent window and wait for response
 * @param request Request message to send to the parent window
 * @param timeout Timeout in ms
 * @returns Payload of the given type, or undefined
 */
export function requestParentResponse(_x) {
  return _requestParentResponse.apply(this, arguments);
}

/**
 * Send a message to the parent window.
 * @param message The message string to send.
 * @param id Optional unique message id. If not provided, a random id will be
 * generated.
 * @param payload Optional payload to send with the message.
 */
function _requestParentResponse() {
  _requestParentResponse = _asyncToGenerator(function* (request) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30000;
    var parent = getWindowParent();
    if (parent == null) {
      throw new Error('window parent is null, unable to send request.');
    }
    return new Promise((resolve, reject) => {
      var timeoutId;
      var id = nanoid();
      var listener = event => {
        var data = event.data;
        if (!isResponse(data)) {
          log.debug('Ignoring non-deephaven response', data);
          return;
        }
        log.debug('Received message', data);
        if ((data === null || data === void 0 ? void 0 : data.id) !== id) {
          log.debug("Ignore message, id doesn't match", data);
          return;
        }
        window.clearTimeout(timeoutId);
        window.removeEventListener('message', listener);
        resolve(data.payload);
      };
      window.addEventListener('message', listener);
      timeoutId = window.setTimeout(() => {
        window.removeEventListener('message', listener);
        reject(new TimeoutError('Request timed out'));
      }, timeout);
      parent.postMessage(makeMessage(request, id), '*');
    });
  });
  return _requestParentResponse.apply(this, arguments);
}
export function sendMessageToParent(message, id, payload) {
  var parent = getWindowParent();
  assertNotNull(parent, 'Parent window is null');
  parent.postMessage(makeMessage(message, id, payload), '*');
}
//# sourceMappingURL=MessageUtils.js.map